import {
    Box,
    CardContent,
    Typography,
    ToggleButton,
    ToggleButtonGroup,
} from '@mui/material';
import Container from 'components/Container';
import Main from 'layouts/Main';
import { Form, VideoPlayer } from './components';
import AppCard from 'components/AppCard';
import { useState } from 'react';

const SigninCover = () => {
    const TutorialVideoIds = {
        individu: '8ce3330ff22c33d178270ec0b36d8987',
        group: 'c66728095b8373ee46c9f6df00557d79',
    };
    const [registerType, setRegisterType] = useState('individu');

    return (
        <Main>
            <Box
                sx={{
                    width: 1,
                    height: 1,
                    overflow: 'hidden',
                    background:
                        'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
                    minHeight: '100vh',
                    py: 6,
                }}
            >
                <Container maxWidth="sm">
                    <AppCard>
                        <CardContent sx={{ p: 4 }}>
                            <Box textAlign="center" mb={4}>
                                <Typography
                                    variant="h4"
                                    component="h2"
                                    fontWeight={700}
                                    color="text.primary"
                                    mb={1}
                                >
                                    Welcome Back
                                </Typography>

                                <Typography
                                    variant="body1"
                                    color="text.secondary"
                                    sx={{ lineHeight: 1.6 }}
                                >
                                    Choose which tutorial to watch:{' '}
                                    <strong>Individual</strong> or{' '}
                                    <strong>Group</strong>
                                </Typography>
                            </Box>
                            <Box mb={2} display="flex" justifyContent="center">
                                <ToggleButtonGroup
                                    size="small"
                                    value={registerType}
                                    exclusive
                                    onChange={(_, value) => {
                                        if (value) setRegisterType(value);
                                    }}
                                >
                                    <ToggleButton value="individu">
                                        Individual
                                    </ToggleButton>
                                    <ToggleButton value="group">
                                        Group
                                    </ToggleButton>
                                </ToggleButtonGroup>
                            </Box>
                            <Box display="flex" justifyContent="center" mb={1}>
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                >
                                    Video Tutorial:
                                </Typography>
                            </Box>
                            <Box mb={3}>
                                <VideoPlayer
                                    key={TutorialVideoIds[registerType]}
                                    videoId={TutorialVideoIds[registerType]}
                                    muted
                                    autoplay={false}
                                />
                            </Box>
                            <Form />
                        </CardContent>
                    </AppCard>
                </Container>
            </Box>
        </Main>
    );
};

export default SigninCover;
